import { Injectable } from '@angular/core';
import {ObjectUtil} from './object.util';

@Injectable({
  providedIn: 'root',
})
export class StringUtils {
  public static addZerosOnLeft(qtd: number, value: string): string {
    let newValue: string = null;
    if (value == null) {
      newValue = '';
    }else {
      newValue = value;
    }
    for (let cont = 0; cont < qtd; cont++) {
      newValue = '0' + newValue;
    }
    return newValue;
  }

  
  public static capitalize (str: string) {
    if (!str) return str;
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
  }


  public static isEmpty(value: string): boolean {
    return ObjectUtil.isNull(value) || value.length === 0;
  }

  public static removeSpecialChart(text: string): string {
    return text.normalize('NFD')
      .replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '');
  }
}
